
import { Grid, Typography } from '@material-ui/core';
import { useEffect, useMemo, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import Data from '../../classes/Data';
import Events from './Events/Events';
import MissionTabs from './MissionTabs/MissionTabs';
import PilotMissionStats from './PilotMissionStats/PilotMissionStats';
import PilotTabs from './PilotTabs/PilotTabs';
import PilotsStatsSummary from './PilotsStatsSummary/PilotsStatsSummary';
import Summary from './Summary/Summary';
import { GridRowData } from '@material-ui/data-grid';
import { Stats } from '../../Interfaces/Interfaces';

const Mission = () => {
	const location = useLocation();
	const locationPathname = location.pathname;
	const fetchedId = locationPathname.split("/")[2];
	const [state, setState] = useState<GridRowData | null>(null);

	const data = useMemo<Data>(() => {
		return new Data(`missionDetails/${fetchedId}`);
	}, [fetchedId])

	useEffect(() => {
		data.GET(setState);
	}, [fetchedId, data])

	return (
		<Grid
			container
			alignItems="center"
			justify="center"
		>
			<Grid item xs={12} >
				<Grid container>
					<Grid item xs={12} style={{ marginTop: 30 }}>
						<Typography variant="h3" align="center" gutterBottom>
							{state?.name}
						</Typography>
					</Grid>
					<Grid item xs={12} style={{ marginTop: 30 }}>
						<Typography variant="h4" align="center" gutterBottom>
							{state?.createdDate} at {state?.time}
						</Typography>
					</Grid>
						{!isNaN(parseInt(locationPathname.split("/")[4])) &&
					<Grid item xs={12} style={{ marginTop: 30 }}>
							<Typography variant="h4" align="center" gutterBottom>
								{`${state?.stats.find((pilot: Stats) => {
									if (pilot.id === parseInt(locationPathname.split("/")[4])) {
										return pilot;
									} return null
								}).playerName}'s Stats:`}
							</Typography>
						</Grid>
					}
				</Grid>
			</Grid>
			{isNaN(parseInt(locationPathname.split("/")[4])) ?
				<MissionTabs />
				:
				<PilotTabs />
				}
			<Grid item xs={10} style={{ marginBottom: 50 }}>
				<Grid container justify="center" spacing={2}  >
					<Switch>
						<Route path="/mission/:id/summary">
							<Summary blueCoalitionDetails={state?.losses.blueDetails} redCoalitionDetails={state?.losses.redDetails} />
						</Route>
						<Route path="/mission/:id/events">
							<Events events={state?.killEvents}/>
						</Route>
						<Route path="/mission/:id/pilots">
							<PilotsStatsSummary pilots={state?.stats}/>
						</Route>
						<Route path="/mission/:id/pilot/:id">
							<PilotMissionStats pilotData={state?.stats.find((pilot: Stats) => {
								const pilotId = parseInt(locationPathname.split("/")[4]);
								if (pilot.id === pilotId) {
									return pilot;
								} return null
							})
							} />
						</Route>
					</Switch>
				</Grid>
			</Grid>
		</Grid>
	)
}
export default Mission ;
